import React from "react";
import { Box, Card, CardContent, Typography } from "@mui/material";
import logoExtended from "../../../../assets/images/paisley-logo-extended.png";

const PaymentCancelled: React.FC = () => {
    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100vh"
            bgcolor="#f5f5f5"
        >
            <Card sx={{ minWidth: 300, textAlign: "center", p: 4 }}>
                <CardContent>
                    <Box 
                        display="flex"
                        justifyContent="center"
                        mb={3}
                    >
                        <img
                            src={logoExtended}
                            alt="Paisley Logo"
                            style={{ maxWidth: "200px", height: "auto" }}
                        />
                    </Box>
                    <Typography variant="h5" component="div" gutterBottom>
                        Your payment was cancelled.
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    );
};

export default PaymentCancelled;
